import {formatUTCDate} from "./dateTimeutils";

import FootballLoginBackground from '../assets/images/football/Login/inBrief_login.webp'
import BasketballLoginBackground from '../assets/images/basketball/Login/inBrief_login.webp'
import FootballMatchboardBackground from '../assets/images/football/Matchboard/InBriefBackground1.png'
import BasketballMatchboardBackground from '../assets/images/basketball/Matchboard/InBriefBackground1.png'
import {SupportedSports} from "../types/generic";
import {HighlightType, SupportedHighlightTypes} from "../types/highlightTypes"
import {HighlightSettings} from "../types/jobTypes";
import {
    defaultOpenerCloserObject
} from "../components/CommonComponents/OpenerCloserComponent/OpenerCloserContentComponent";
import {Organization, User} from "../types/users";
import {GridColDef} from "@mui/x-data-grid";
import { GridValueGetter } from '@mui/x-data-grid';
import {SocialFormControl, SocialPlatformNames} from "../types/socialTypes";
import FacebookIcon from "../assets/images/Social/facebook.svg";
import InstagramIcon from "../assets/images/Social/instagram.svg";
import TikTokIcon from "../assets/images/Social/tiktok.svg";
import YoutubeIcon from "../assets/images/Social/youtube.svg";
import DailyMotionIcon from "../assets/images/Social/dailyMotion.svg";
import React from "react";
import {Clip, FormClip} from "../types/clipTypes";

export const SportImagesDict = {
    Login:{
        football: FootballLoginBackground,
        basketball: BasketballLoginBackground,
    },
    Matchboard:{
        football:FootballMatchboardBackground,
        basketball: BasketballMatchboardBackground
    }
}

export const mamTableColumns = [
    { field: "title", headerName: "Title", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "key_moment_type", headerName: "Key Moment Type", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "player", headerName: "Player", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "team", headerName: "Team", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "period", headerName: "Period", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "game_time", headerName: "Game Time", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "rating", headerName: "Rating", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "duration", headerName: "Duration", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "extraction_schedule", headerName: "Extraction Schedule", headerClassName: 'super-app-theme--header', width: 150, valueGetter: (params: any) => formatUTCDate(params) },
    { field: "match", headerName: "Match", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "matchday", headerName: "Match Day", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "competition", headerName: "Competition", headerClassName: 'super-app-theme--header', width: 150 },
    { field: "match_date", headerName: "Match Date", headerClassName: 'super-app-theme--header', width: 150, valueGetter: (params: any) => formatUTCDate(params)},
    { field: "aspect_ratio", headerName: "Aspect Ratio", headerClassName: 'super-app-theme--header', width: 150 },
]

export const userColumns: GridColDef[] = [
    { field: "id", headerName: "Id", headerClassName: 'super-app-theme--header', flex: 1, minWidth: 250 },
    { field: "email", headerName: "Email", headerClassName: 'super-app-theme--header', flex: 1, minWidth: 250 },
    { field: "username", headerName: "Username", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "name", headerName: "Name", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "surname", headerName: "Surname", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "roles", headerName: "Role", headerClassName: 'super-app-theme--header', flex: 1, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r.name).join(", ")
                : params;
        }, },
    { field: "organizations", headerName: "Organization", headerClassName: 'super-app-theme--header', flex: 1, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r ? r.name : '').join(", ")
                : params;
        }, }
]

export const organizationColumns: GridColDef[] = [
    { field: "id", headerName: "Id", headerClassName: 'super-app-theme--header', flex: 1, minWidth: 250 },
    { field: "name", headerName: "Name", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "users", headerName: "Users", headerClassName: 'super-app-theme--header', flex: 2, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r.email).join(", ")
                : params;
        },
    },
    { field: "competitions", headerName: "Competition", headerClassName: 'super-app-theme--header', flex: 2, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r.name + " - " + r.season).join(", ")
                : params;
        }, }
]

export const JobsTableColumns: GridColDef[] = [
    { field: "id", headerName: "Job id" },
    { field: "event_id", headerName: "Event ID" },
    { field: "competition_id", headerName: "Competition ID"},
    { field: "competition_season", headerName: "Competition Season"},
    { field: "competition_type", headerName: "Competition Type"},
    { field: "competition", headerName: "Competition", headerClassName: 'super-app-theme--header', flex: 3, valueGetter: (value, row: any) => `${row.competition_name || ''} ${row.competition_season || ''}`,},
    { field: "event_name", headerName: "Event Name", headerClassName: 'super-app-theme--header', flex: 3},
    { field: "event_date", headerName: "Event Date", headerClassName: 'super-app-theme--header', flex: 1.8, valueFormatter: (params: any) => formatUTCDate(params) ,},
    { field: "job_name", headerName: "Job Name", headerClassName: 'super-app-theme--header', flex: 2},
    { field: "extraction_schedule", headerName: "Extraction Schedule", flex: 1.8, headerClassName: 'super-app-theme--header', valueFormatter: (params: any) => formatUTCDate(params)  },
    { field: "status", headerName: "Status", headerClassName: 'super-app-theme--header' , flex: 1.25},
    { field: "target", headerName: "Target", headerClassName: 'super-app-theme--header' , flex: 1},
    { field: "datasource_type", headerName: "DataSource", headerClassName: 'super-app-theme--header', flex: 1.25 },
]

export const clipGroupPageSize = 15;
export const rowsJobsTablePageSize = 10;

export const maxAudioFadeDuration = 0.5;
export const minAudioFadeDuration = 0.2;
export const defaultFadeDuration = 0.3
export const fadeDurationStep = 0.1


const visibleHighlightTypeDict: Record<SupportedSports, HighlightType[]> = {
    'football': [{
        type: "Regular",
        label: "Regular"
        },
    ],
    'basketball': [
        {
            type: "Regular",
            label: "Regular"
        },
        {
            type: "Fast",
            label: "Fast"
        },
        {
            type: "Pistolero",
            label: "Pistolero"
        }
    ],
}

export const visibleHighlightTypes = visibleHighlightTypeDict[process.env.REACT_APP_SPORT as SupportedSports]

export const HighlightTypeObjects: Record<SupportedHighlightTypes, HighlightSettings> = {
    Regular:{
        type: 'Regular',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: minAudioFadeDuration
    },
    Fast:{
        type: 'Fast',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        music: {
            file_name: '',
            src_url: '',
            label: '',
        }
    },
    Pistolero:{
        type: 'Pistolero',
        opener: defaultOpenerCloserObject,
        closer: defaultOpenerCloserObject,
        fade: false,
        fade_duration: minAudioFadeDuration
    }
}

export const defaultUser: User = {
    id: '',
    email: '',
    name: '',
    surname: '',
    username: '',
    roles: [],
    password: "",
    organizations: []
}

export const defaultOrganization: Organization = {
    id: '',
    name: '',
    users: [],
    competitions: [],
    teams: []
}

export const enum EntityType {
    users = "users",
    organizations = "organizations",
}


export const socialFormFields: Record<SocialPlatformNames, SocialFormControl[]> = {
    [SocialPlatformNames.dailyMotion]: [
        {
            name: 'name',
            type: "text",
            label: "Account Name",
        },
        {
            name: 'account_id',
            type: "text",
            label: "Account ID",
        },
        {
            name: 'client_id',
            type: "text",
            label: "Client ID",
        },
        {
            name: 'token',
            type: "text",
            label: "Token",
            secret: true,
        },
    ],
    [SocialPlatformNames.instagram]: [
        {
            name: 'name',
            type: "text",
            label: "AccountName",
        }
    ],
    [SocialPlatformNames.facebook]: [
        {
            name: 'name',
            type: "text",
            label: "Account Name",
        }

    ],
    [SocialPlatformNames.youtube]: [
        {
            name: 'name',
            type: "text",
            label: "Account Name",
            visibleUpdate: true,
            visibleCreate: true,
        },
    ],
    [SocialPlatformNames.tiktok]: []
}

export const defaultFormClip: FormClip = {
    title: "",
    description: "",
    key_moment_type: "",
    player: "",
    team: "",
    period: "",
    game_time: "00:00",
    manual_rating: 2.5,
    duration: 0,
    job_id: "",
    event_id: "",
    tags: [],
    owngoal: false,
    penalty: false
}